import React, { Fragment, useState, useEffect } from 'react';
import DataTable from 'react-data-table-component';
import { H4 } from '../../../../AbstractElements';
import {
    Button, Col, Container, DropdownItem, DropdownMenu,
    DropdownToggle, Form, FormGroup, Input, Label,
    Media, Row, UncontrolledDropdown
} from 'reactstrap';
import { MoreVertical, PlusCircle } from 'react-feather';
import CommonModal from '../../../UiKits/Modals/common/modal';
import axios from 'axios';
import moment from 'moment';
import Swal from 'sweetalert2';
import { baseURL, getPublicS3Url } from '../../../../Services/api/baseURL';
import { FaPen, FaTrash } from 'react-icons/fa';
import Loader from '../../../Loader/Loader';
// import { useDispatch, useSelector } from 'react-redux';
// import { fetchMainCategories } from '../../../../redux/slice/maincategory.slice';

const CategoryTable = () => {
    const userRole = JSON.parse(localStorage.getItem('role_name'));
    const token = JSON.parse(localStorage.getItem("token"));

    const [editData, setEditData] = useState(null);
    const [editMetaData, setEditMetaData] = useState(null);
    console.log(editMetaData, "editMetaData")

    const [searchTerm, setSearchTerm] = useState('');
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isMetaOpen, setIsMetaOpen] = useState(false);

    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [loading, setLoading] = useState(false); // Define setLoading using useState
    const [formData, setFormData] = useState({
        name: '',
        status: 'active',
        image: null,
        description: '',
        imagePreview: null,
        metaTitle: "",
        metaDescription: "",
        originalImage: null,
        imageChanged: false
    });
    
    const [metaData, setMetaData] = useState({
        metaTitle: "",
        metaDescription: ""
    });
    console.log(metaData, "metaData")

    // const dispatch = useDispatch();
    // const { categories, totalRows /* removed loading from here */ } = useSelector(state => state.maincategory); // Adjusted selector and removed loading
    const [categories, setCategories] = useState([]);

    const [pagination, setPagination] = useState({
        page: 1,
        perPage: 10,
        totalRows: 0
    });

    const getFileNameFromKey = (key) => {
        if (!key) return '';
        try {
            const s = String(key);
            return s.split('/').pop();
        } catch {
            return String(key);
        }
    };

    const fetchCategories = async () => {
        setLoading(true);
        try {
            const rawToken = localStorage.getItem('token');
            if (!rawToken) throw new Error("No token found in localStorage");

            const token = JSON.parse(rawToken);
            const response = await axios.get(`${baseURL}/api/category`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            const categoriesData = response.data || [];

            setCategories(categoriesData);
            setPagination(prev => ({
                ...prev,
                totalRows: categoriesData.length,
            }));

        } catch (error) {
            console.error('Error fetching categories:', error);
            Swal.fire({
                title: "Error",
                text: error?.response?.data?.message || "Failed to fetch categories",
                icon: "error",
                confirmButtonColor: "#fc2c54",
            });
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchCategories();
    }, []);

    // Modal Toggle
    const toggleModal = () => {
        setIsModalOpen(!isModalOpen);
        if (isModalOpen) {
            resetForm();
        }
    };
    const toggleMetaModal = () => {
        setIsMetaOpen(!isMetaOpen);
        if (isMetaOpen) {
            resetMetaForm();
        }
    };

    // Toggle Delete Modal
    const toggleDeleteModal = () => {
        setIsDeleteModalOpen(!isDeleteModalOpen);
        if (isDeleteModalOpen) {
            setSelectedCategory(null);
        }
    };

    // Reset Form
    const resetForm = () => {
        setEditData(null);
        setFormData({
            name: '',
            description: '',
            status: 'active',
            image: null,
            imagePreview: null,
            originalImage: null,
            imageChanged: false
        });
    };
    const resetMetaForm = () => {
        setEditMetaData(null);
        setMetaData({
            metaTitle: "",
            metaDescription: ""
        });
    };

    // Input Change Handler
    const handleInputChange = (e) => {
        const { name, value, files } = e.target;

        if (name === 'image' && files[0]) {
            const file = files[0];
            setFormData(prev => ({
                ...prev,
                image: file,
                imagePreview: URL.createObjectURL(file),
                imageChanged: true
            }));
        } else {
            setFormData(prev => ({
                ...prev,
                [name]: value
            }));
        }
    };

    // Remove Image Handler
    const handleRemoveImage = () => {
        setFormData(prev => ({
            ...prev,
            image: null,
            imagePreview: null,
            imageChanged: true,
            originalImage: null
        }));
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setMetaData(prev => ({
            ...prev,
            [name]: value
        }));

    }

    // Submit Handler
    const handleSubmit = async (e) => {
        e.preventDefault();
        
        // Validation: Ensure image exists (either new file or existing image when not editing)
        if (!formData.image && !formData.originalImage) {
            Swal.fire({
                title: "Validation Error",
                text: "Please upload an image for the category",
                icon: "warning",
                confirmButtonColor: "#fc2c54",
            });
            return;
        }

        setLoading(true);

        const formPayload = new FormData();
        formPayload.append('name', formData.name);
        formPayload.append('description', formData.description);
        formPayload.append('status', formData.status);

        // Only append image if it's a new file (changed during edit or new category)
        if (formData.imageChanged && formData.image instanceof File) {
            formPayload.append('image', formData.image);
        }

        try {
            if (editData) {
                // Update existing category
                await axios.put(`${baseURL}/api/category/${editData._id}`, formPayload, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'multipart/form-data'
                    }
                });

                Swal.fire({
                    title: "Category Updated!",
                    icon: "success",
                    confirmButtonColor: "#fc2c54",
                });
            } else {
                // Add new category
                await axios.post(`${baseURL}/api/category`, formPayload, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'multipart/form-data'
                    }
                });

                Swal.fire({
                    title: "Category Added!",
                    icon: "success",
                    confirmButtonColor: "#fc2c54",
                });
            }

            toggleModal();
            fetchCategories();
        } catch (error) {
            console.error('Error submitting category:', error);
            Swal.fire({
                title: "Error",
                text: error.response?.data?.error || "Failed to submit category",
                icon: "error",
                confirmButtonColor: "#fc2c54",
            });
        } finally {
            setLoading(false);
        }
    };



    const handleMetaSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const response = await axios.put(`${baseURL}/api/category/${editMetaData._id}`, metaData, {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            });

            Swal.fire({
                title: response?.data?.message,
                icon: "success",
                confirmButtonColor: "#fc2c54",
            });
            toggleMetaModal();
            fetchCategories();
        } catch (error) {
            console.error('Error submitting category:', error);
            Swal.fire({
                title: "Error",
                text: error.response?.data?.message || "Failed to submit category",
                icon: "error",
                confirmButtonColor: "#fc2c54",

            })
        } finally {
            setLoading(false);
        }
    }



    // Edit Category
    const handleEditCategory = (row) => {
        setEditData(row);
        setFormData({
            name: row.name,
            description: row.description,
            status: row.status,
            image: row.image,
            imagePreview: row.image || null,
            originalImage: row.image,
            imageChanged: false,
            metaTitle: row.metaTitle || "",
            metaDescription: row.metaDescription || ""
        });
        setIsModalOpen(true);
    };

    const handleAddMetaData = (row) => {
        setEditMetaData(row);
        setMetaData({
            metaTitle: row.metaTitle || "",
            metaDescription: row.metaDescription || ""
        });
        setIsMetaOpen(true);
    };




    // Delete Category
    const handleDeleteCategory = async () => {
        if (!selectedCategory) return;

        setLoading(true);
        try {
            await axios.delete(`${baseURL}/api/category/${selectedCategory._id}`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            Swal.fire({
                title: "Category Deleted!",
                icon: "success",
                confirmButtonColor: "#fc2c54",
            });

            toggleDeleteModal();
            fetchCategories(pagination.page);
        } catch (error) {
            console.error('Error deleting category:', error);
            Swal.fire({
                title: "Error",
                text: error.response?.data?.message || "Failed to delete category. This category may be in use by subcategories.",
                icon: "error",
                confirmButtonColor: "#fc2c54",
            });
        } finally {
            setLoading(false);
        }
    };

    // Open Delete Modal
    const openDeleteModal = (row) => {
        setSelectedCategory(row);
        setIsDeleteModalOpen(true);
    };

    // Table Columns
    const columns = [
        {
            name: 'Image',
            selector: row => row.images?.[0],
            sortable: false,
            center: true,
            cell: row => (
                <div className="blog-image-container" style={{ padding: '2px' }}>
                    {row.image ? (
                        <img
                            src={getPublicS3Url(row.image)}
                            alt={row.name}
                            style={{
                                width: '60px',
                                height: '60px',
                                objectFit: 'cover',
                                borderRadius: '8px'
                            }}
                        />
                    ) : (
                        <div
                            style={{
                                width: '60px',
                                height: '60px',
                                background: '#f0f0f0',
                                borderRadius: '4px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}
                        >
                            No Image
                        </div>
                    )}
                </div>
            ),
            width: '200px'
        },
        {
            name: 'Category Name',
            selector: row => row.name,
            sortable: true,
            center: true,
            width: '200px'

        },
        {
            name: 'Description',
            selector: row => row.description || 'No description available',
            sortable: true,
            width: '400px',
            cell: row => (
                <div 
                    style={{
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        textAlign: 'left',
                        padding: '10px 8px',
                        color: '#333',
                        fontSize: '14px',
                        maxWidth: '300px',
                    }}
                    title={row.description || 'No description available'}
                >
                    {row.description || 'No description available'}
                </div>
            ),
        },
        {
            name: 'Created Date',
            selector: row => row.createdAt,
            sortable: true,
            center: true,
            width: '200px',
            cell: row => moment(row.createdAt).format("DD/MM/YYYY"),

        },
        {
            name: 'Updated Date',
            selector: row => row.updatedAt,
            sortable: true,
            center: true,
            width: '200px',
            cell: row => moment(row.updatedAt).format("DD/MM/YYYY"),
        },
        {
            name: 'Actions',
            cell: row => (
                <UncontrolledDropdown className="action_dropdown">
                    <DropdownToggle className="action_btn">
                        <MoreVertical size={16} color="#000"/>
                    </DropdownToggle>
                    <DropdownMenu>
                        <DropdownItem onClick={() => handleEditCategory(row)}>
                            <FaPen size={15} /> Edit
                        </DropdownItem>
                      
                        {userRole && userRole.toLowerCase() === 'admin' && (
                            <DropdownItem onClick={() => openDeleteModal(row)} className="delete_item">
                                <FaTrash size={15} /> Delete
                            </DropdownItem>
                        )}
                    </DropdownMenu>
                </UncontrolledDropdown>
            ),
            sortable: false,
            center: true,
            width: "120px",
        }
    ];

    // Filtered Categories
    const filteredCategories = Array.isArray(categories)
        ? categories.filter(item =>
            (item.name || '').toLowerCase().includes(searchTerm.toLowerCase())
        )
        : [];

    return (
        <Fragment>
            <Row className='pb-4'>
                <div className='d-flex justify-content-between align-items-center'>
                    <H4>Category List</H4>
                    <div className="file-content">
                        <Media>
                            <div className='mb-0 form-group position-relative search_outer d-flex align-items-center'>
                                <i className='fa fa-search'></i>
                                <input
                                    className='form-control border-0'
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                    type='text'
                                    placeholder='Search...'
                                />
                            </div>
                            {userRole && userRole.toLowerCase() === 'admin' && (
                                <Media body className='text-end ms-3'>
                                    <Button className='btn btn-primary d-flex align-items-center' onClick={toggleModal}>
                                        <PlusCircle />
                                        Add Category
                                    </Button>
                                </Media>
                            )}
                        </Media>
                    </div>
                </div>
            </Row>

            <DataTable
                data={filteredCategories}
                columns={columns}
                pagination
                paginationPerPage={pagination.perPage}
                paginationRowsPerPageOptions={[10, 20, 50, 100]}
                onChangePage={(page) => setPagination(prev => ({ ...prev, page }))}
                onChangeRowsPerPage={(newPerPage) => setPagination(prev => ({ ...prev, perPage: newPerPage }))}
                progressPending={loading}
                progressComponent={<Loader />}
            />

            {/* Add/Edit Category Modal */}
            <CommonModal
                isOpen={isModalOpen}
                title={editData ? "Edit Category" : "Add Category"}
                className="store_modal"
                toggler={toggleModal}
                size="md"
            >
                <Container>
                    <Form onSubmit={handleSubmit}>
                        <Col xxl={12}>
                            <FormGroup>
                                <Label className="font-medium text-base">
                                    Category Name <span className="text-danger">*</span>
                                </Label>
                                <Input
                                    type="text"
                                    name="name"
                                    value={formData.name}
                                    onChange={handleInputChange}
                                    required
                                />
                            </FormGroup>
                            <FormGroup>
                                <Label className="font-medium text-base">
                                    Description <span className="text-danger">*</span>
                                </Label>
                                <Input
                                    type="text"
                                    name="description"
                                    value={formData.description}
                                    onChange={handleInputChange}
                                    required
                                />
                            </FormGroup>
                            <FormGroup>
                                <Label className="font-medium text-base">
                                    Image <span className="text-danger">*</span>
                                </Label>
                                <div className="position-relative">
                                    <Input
                                        type="file"
                                        name="image"
                                        id="imageInput"
                                        onChange={handleInputChange}
                                        accept="image/*"
                                        required={!editData || !formData.originalImage}
                                        style={{ 
                                            position: 'relative',
                                            zIndex: editData && formData.originalImage && !formData.imageChanged ? 0 : 'auto'
                                        }}
                                    />
                                    {editData && formData.originalImage && !formData.imageChanged && (
                                        <div 
                                            style={{
                                                position: 'absolute',
                                                top: 0,
                                                left: 0,
                                                right: 0,
                                                bottom: 0,
                                                pointerEvents: 'none',
                                                display: 'flex',
                                                alignItems: 'center',
                                                paddingLeft: '12px',
                                                background: 'white',
                                                border: '1px solid #ced4da',
                                                borderRadius: '0.25rem',
                                                zIndex: 1
                                            }}
                                        >
                                            <span style={{ color: '#6c757d', fontSize: '0.875rem' }}>
                                                {getFileNameFromKey(formData.originalImage)}
                                            </span>
                                        </div>
                                    )}
                                </div>
                                <small className="text-muted d-block mt-1">
                                    {editData ? "Choose a new file to replace the current image" : ""}
                                </small>
                                {formData.imagePreview && (
                                    <div className="mt-2">
                                        <div style={{ marginBottom: '10px' }}>
                                            <img
                                                src={
                                                    formData.imagePreview.includes("blob:")
                                                        ? formData.imagePreview
                                                        : getPublicS3Url(formData.imagePreview)
                                                }
                                                alt="Category Preview"
                                                style={{
                                                    maxWidth: '200px',
                                                    maxHeight: '200px',
                                                    objectFit: 'cover',
                                                    borderRadius: '8px'
                                                }}
                                            />
                                        </div>
                                        {editData && (
                                            <Button
                                                type="button"
                                                color="danger"
                                                size="sm"
                                                onClick={handleRemoveImage}
                                            >
                                                Remove Image
                                            </Button>
                                        )}
                                    </div>
                                )}
                            </FormGroup>

                            <Row className="text-center">
                                <Button
                                    type="submit"
                                    className="btn btn-primary"
                                    disabled={loading}
                                >
                                    {editData ? "Update Category" : "Add Category"}
                                </Button>
                            </Row>
                        </Col>
                    </Form>
                </Container>
            </CommonModal>

            {/* Meta Data Modal */}
            <CommonModal
                isOpen={isMetaOpen}
                title={editMetaData ? "Edit Meta Data" : "Add Meta Data"}
                className="store_modal"
                toggler={toggleMetaModal}
                size="md"
            >
                <Container>
                    <Form onSubmit={handleMetaSubmit}>
                        <Col xxl={12}>
                            <FormGroup>
                                <Label className="font-medium text-base">
                                    Meta Title <span className="text-danger">*</span>
                                </Label>
                                <Input
                                    type="text"
                                    name="metaTitle"
                                    value={metaData.metaTitle}
                                    onChange={handleChange}
                                    required
                                />
                            </FormGroup>
                            <FormGroup>
                                <Label className="font-medium text-base">
                                    Meta Description <span className="text-danger">*</span>
                                </Label>
                                <Input
                                    type="text"
                                    name="metaDescription"
                                    value={metaData.metaDescription}
                                    onChange={handleChange}
                                    required
                                />
                            </FormGroup>
                            <Row className="text-center">
                                <Button
                                    type="submit"
                                    className="btn btn-primary"
                                    disabled={loading}
                                >
                                    {editMetaData ? "Update Meta Data" : "Add Meta Data"}
                                </Button>
                            </Row>
                        </Col>
                    </Form>
                </Container>
            </CommonModal>


            {/* Delete Confirmation Modal */}
            <CommonModal
                isOpen={isDeleteModalOpen}
                title="Delete Category"
                toggler={toggleDeleteModal}
                className="delete_modal"
                size="md"
            >
                <Container>
                    <div className="text-center mb-4">
                        <h5>Are you sure you want to delete this category?</h5>
                        <p className="text-muted">
                            {selectedCategory?.name}
                        </p>
                    </div>
                    <Row className="text-center">
                        <Col xs={6}>
                            <Button
                                type="button"
                                className="btn btn-secondary w-100"
                                onClick={toggleDeleteModal}
                            >
                                Cancel
                            </Button>
                        </Col>
                        <Col xs={6}>
                            <Button
                                type="button"
                                className="btn btn-danger w-100"
                                onClick={handleDeleteCategory}
                                disabled={loading}
                            >
                                Delete
                            </Button>
                        </Col>
                    </Row>
                </Container>
            </CommonModal>
        </Fragment>
    );
}

export default CategoryTable;